import { TranslateFunc } from '@ha/intl';
import isEmailCorrect from 'ha/utils/isEmailCorrect';

interface Values {
  email?: string;
  password?: string;
}

export default function validateForm(
  { email, password }: Values,
  T: TranslateFunc,
) {
  const errors: Values = {};

  if (!email) {
    errors.email = T('This field is required');
  } else if (!isEmailCorrect(email)) {
    errors.email = T('Email is not valid');
  }

  if (!password) {
    errors.password = T('This field is required');
  }

  return errors;
}
